import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        flex: 1,
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        marginTop: 14
    },

    text: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 64
    },
});